import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaXTwitter,
  FaEnvelope,
  FaPhone,
  FaLocationDot,
} from "react-icons/fa6";


const Footer = ({ showCta = false }) => {
  return (
 <footer className={`relative bg-[#0f172a] text-white ${showCta ? "pt-0 pb-16" : "py-16"}`}>

    <div className={`max-w-7xl mx-auto px-6 ${showCta ? "pt-16" : ""}`}>

        <div className="grid md:grid-cols-5 gap-12 mb-12">

          {/* Company Intro */}
          <div>
           <div className="flex items-center gap-3 mb-6">
<img
  src={`${process.env.PUBLIC_URL}/images/logo/g1gold-white-logo.webp`}
  alt="G1 Gold Icon"
  className="h-10 w-auto object-contain"
/>

<img
  src={`${process.env.PUBLIC_URL}/images/logo/g1gold-white-name.webp`}
  alt="G1 Gold"
  className="h-8 w-auto object-contain"
/>
</div>

            <p className="text-gray-400 leading-relaxed">
            G-One Gold Pvt Ltd is a trusted gold buyer affiliated with Indian Gold Buyers, offering transparent gold evaluation, fair pricing, and instant payment services.
            </p>

         <p className="mt-4 text-sm text-gray-400 flex items-center gap-2 flex-wrap">

</p>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-3 text-gray-400">
              <li><a href="https://g1gold.com/" className="hover:text-[#EFCB57]">Home</a></li>
              <li><a href="https://g1gold.com/about-us" className="hover:text-[#EFCB57]">About Us</a></li>
              <li><a href="https://g1gold.com/careers" className="hover:text-[#EFCB57]">Careers</a></li>
              <li><a href="https://g1gold.com/branches" className="hover:text-[#EFCB57]">Branches</a></li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Information</h4>
            <ul className="space-y-3 text-gray-400">
              <li><a href="https://g1gold.com/howitworks" className="hover:text-[#EFCB57]">How It Works</a></li>
              <li><a href="https://g1gold.com/services" className="hover:text-[#EFCB57]">Services</a></li>
              <li><a href="https://g1gold.com/why-g1-gold" className="hover:text-[#EFCB57]">Why G1 Gold</a></li>
              <li><a href="https://g1gold.com/gold-calculator" className="hover:text-[#EFCB57]">Contact</a></li>
                            <li><a href="https://g1gold.com/blogs/" className="hover:text-[#EFCB57]">blogs</a></li>
            </ul>
          </div>

          {/* Customer Tools */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Customer Tools</h4>
            <ul className="space-y-3 text-gray-400">
              <li><a href="https://g1gold.com/gold-calculator" className="hover:text-[#EFCB57]">Gold Calculator</a></li>
              <li><a href="https://g1gold.com/gold-savings-scheme" className="hover:text-[#EFCB57]">Gold Savings Scheme</a></li>
           
            </ul>
          </div>

          {/* Connect */}
        {/* Connect */}
{/* Connect */}
<div>
  <h4 className="font-semibold text-lg mb-4">Connect</h4>

  <div className="space-y-3 mb-5">
    <a
      href="tel:+917996800900"
      className="flex items-center gap-3 text-gray-400 hover:text-[#EFCB57] transition-colors"
    >
      <FaPhone className="shrink-0 text-[#FFD51F]" />
      <span>+91 7996 800 900</span>
    </a>
  

    <a
      href="mailto:info@g1gold.in"
      className="flex items-center gap-3 text-gray-400 hover:text-[#EFCB57] transition-colors"
    >
      <FaEnvelope className="shrink-0 text-[#FFD51F]" />
      <span>info@g1gold.in</span>
    </a>

    <a
      href="mailto:g1goldcompany@gmail.com"
      className="flex items-center gap-3 text-gray-400 hover:text-[#EFCB57] transition-colors"
    >
      <FaEnvelope className="shrink-0 text-[#FFD51F]" />
      <span>g1goldcompany@gmail.com</span>
    </a>
<div className="flex items-start gap-3 text-gray-400">
  <FaLocationDot className="mt-1.5 shrink-0 text-[#FFD51F]" />

  <p className="leading-7 mb-4 text-[15px] min-w-[260px]">
       1st Floor, Satya Sai Complex,<br/>
     No. 224, 14th Cross, <br/>
     Sampige Road, Malleswaram,<br/>
      Bengaluru, Karnataka - 560003
  </p>
</div>
  </div>

  <div className="flex items-center gap-4 text-xl text-gray-400">
    <a
      href="https://www.instagram.com/g__one_gold/?hl=en"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-[#EFCB57]"
      aria-label="Instagram"
    >
      <FaInstagram />
    </a>

    <a
      href="https://x.com/G1goldcompany"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-[#EFCB57]"
      aria-label="X"
    >
      <FaXTwitter />
    </a>

    <a
      href="https://www.facebook.com/profile.php?id=61588184154344"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-[#EFCB57]"
      aria-label="Facebook"
    >
      <FaFacebookF />
    </a>

    <a
      href="mailto:g1goldcompany@gmail.com"
      className="hover:text-[#EFCB57]"
      aria-label="Email"
    >
      <FaEnvelope />
    </a>

    <a
      href="https://www.youtube.com/@g-onegoldcompany"
      target="_blank"
      rel="noopener noreferrer"
      className="hover:text-[#EFCB57]"
      aria-label="YouTube"
    >
      <FaYoutube />
    </a>
  </div>
</div>

        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-gray-400 text-sm">
            © 2026 G1 Gold. All rights reserved.
          </p>

          <div className="flex gap-6 text-sm text-gray-400">
            <a href="https://g1gold.com/privacy" className="hover:text-[#EFCB57]">
              Privacy Policy
            </a>

            <a href="https://g1gold.com/terms" className="hover:text-[#EFCB57]">
              Terms of Service
            </a>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;